import React from "react";
import "./stylescroll.css";
import {
  CheckCircleTwoTone,
  ClockCircleOutlined,
  ForwardOutlined,
} from "@ant-design/icons";
// import { CalendarOutlined } from "@ant-design/icons";
import { Badge, Card, Tag } from "antd";
import NoImage from "../../assets/no-image.jpg";

const link = "https://jerhrgroup.com/webinars/";

const CardList3 = ({ data }) => {
  const renderCard = (item, index, isFromUpcomingSection = false) => {
    return (
      <Card
        key={item.id}
        className={`custom-card ${
          index % 2 === 0 ? "card-light-blue" : "card-light-gray"
        }`}
        size="small"
        hoverable
      >
        <div className="card-body">
          {/* Left Image */}
          <div className="card-image-wrapper">
            <img
              src={
                isFromUpcomingSection
                  ? item?.featured_image
                  : item?.youtube_image_overlay || NoImage
              }
              alt={""}
              className="card-image"
            />
          </div>

          {/* Right Content */}
          <div className="card-content">
            {/* Title */}
            <p className="card-title-text-wrap">{item.title}</p>

            {/* Date, Tag, and Know More */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px",
                fontSize: "12.5px",
                color: "#757575",
              }}
            >
              {/* Left: Date + Tag */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {/* <CalendarOutlined /> */}
                {/* {item.date} */}
                <Tag
                  color={isFromUpcomingSection ? "geekblue" : "green"}
                  className={isFromUpcomingSection ? "shimmer-tag" : ""}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: 500,
                    fontSize: "11.75px",
                    padding: "0 6px",
                    marginBottom: "0",
                  }}
                >
                  {isFromUpcomingSection ? (
                    <>
                      <ClockCircleOutlined />
                      UPCOMING
                      <Badge status="processing" color="#FF5722" />
                    </>
                  ) : (
                    <>
                      <CheckCircleTwoTone />
                      COMPLETED
                    </>
                  )}
                </Tag>
              </div>

              {/* Right: Know More */}
              <div className="custom-extra" style={{ whiteSpace: "nowrap" }}>
                <a
                  href={item?.youtube_video_link || link}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#1890ff",
                    fontSize: "13px",
                  }}
                >
                  Know More
                </a>
                <ForwardOutlined className="see-more-icon" />
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Card
      title={
        <div className="moving-gradient-header">
          <span>WEBINARS</span>
        </div>
      }
      size="small"
      headStyle={{
        padding: 0,
        borderBottom: "none",
      }}
      bodyStyle={{
        padding: 16,
      }}
      style={{ borderRadius: 16, overflow: "hidden", maxHeight: "47vh" }}
    >
      <div className="scroll-container" style={{ maxHeight: "42vh" }}>
        {data?.["Upcoming Webinars"]?.map(
          (item, index) => renderCard(item, index, true) // true = from upcoming section → use featured_image
        )}
        {data?.["Recent Webinars"]?.map(
          (item, index) => renderCard(item, index, false) // false = use youtube_image_overlay
        )}
      </div>
    </Card>
  );
};

export default CardList3;
